module.exports = __webpack_public_path__ + "static/media/partner.f4f77259.svg";